export default __webpack_public_path__ + "static/media/sub-category-fitness-yogaStudio.07e9d740.jpg";